module.exports = __webpack_public_path__ + "img/3x.5a0d6a7.jpg";